export default "/images/vendor/flag-icon-css/flags/4x3/pr.svg?97520818c4ec402b4ba89f984169a07b";